import { render, staticRenderFns } from "./ModalEditarGeo.vue?vue&type=template&id=bcb6c884&scoped=true&"
import script from "./ModalEditarGeo.vue?vue&type=script&lang=js&"
export * from "./ModalEditarGeo.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditarGeo.vue?vue&type=style&index=0&id=bcb6c884&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb6c884",
  null
  
)

export default component.exports